import { IonLabel, useIonViewDidEnter, IonSegment, IonSegmentButton } from '@ionic/react'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getRulesSelector } from '../../rules/selectors'
import { runAllRules, setIsLoading } from '../../rules/store/rules.actions'
import { setSelectedOption } from '../store/completeChart.actions'
import { getCompleteChartSelector } from '../selectors'
import { CompleteChartConstants } from '../store/completeChart.constants'
import './ErrorsAndWarningsSegmentButton.component.css'

const ErrorsAndWarningsSegmentButton: React.FC = () => {
  const dispatch = useDispatch()
  const rulesState = useSelector(getRulesSelector)
  const { selectedOption } = useSelector(getCompleteChartSelector)
  const { groupedRulesErrors } = rulesState

  useIonViewDidEnter(() => {
    dispatch(setIsLoading(true))
    dispatch(runAllRules())
  })

  const errorsWarningsCount = (eType: string) => {
    return Object.values(groupedRulesErrors)
      .flat()
      .filter((error) => error.errorType === eType).length
  }

  return (
    <IonSegment
      color='primary'
      value={selectedOption}
      className='lock-in-chart-segment-wrapper'
      onIonChange={(e: any) => {
        dispatch(setSelectedOption(e.target?.value))
      }}>
      <IonSegmentButton
        className='lock-in-chart-segment-button'
        data-testid='Errors-segment-item'
        value={CompleteChartConstants.SET_ERRORS_TAB}>
        <IonLabel>Errors ({errorsWarningsCount('error')})</IonLabel>
      </IonSegmentButton>
      <IonSegmentButton
        className='lock-in-chart-segment-button'
        data-testid='Warnings-segment-item'
        value={CompleteChartConstants.SET_WARNINGS_TAB}>
        <IonLabel>Warnings ({errorsWarningsCount('warning')})</IonLabel>
      </IonSegmentButton>
    </IonSegment>
  )
}

export default ErrorsAndWarningsSegmentButton
